import IconComponent from "icons/IconComponent";

import CancelIcon from "./cancel.svg";

export default (CancelIcon as any) as IconComponent;
